import { render } from "./Call.vue?vue&type=template&id=021aeed1&scoped=true"
const script = {}

import "./Call.vue?vue&type=style&index=0&id=021aeed1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021aeed1"]])

export default __exports__